module.exports = __webpack_public_path__ + "static/media/DSC_0103-3.f187fcf6.jpg";